export const REGEX = {
    multiPort: /^([0-9]+)(,[0-9]+)*$/g
}

// Base execute result
export const EXECUTE_RESULT = {
    SUCCESS: 0,
    ERROR: 1,
};

// API call status
export const API_CALL_STATUS = {
    LOADING: 0,
    SUCCESS: 1,
    FAILED: 2,
};

// Pagination status
export const PAGINATION_STATUS = {
    ALL: 0,
    ACTIVATED: 1,
    DEACTIVATED: 2,
};

// Action
export const ACTION = {
    OPEN_POPUP_FIXED_RENTAL_CREATE: "OPEN_POPUP_FIXED_RENTAL_CREATE",
    OPEN_POPUP_FIXED_RENTAL_EXISTING_MACHINE: "OPEN_POPUP_FIXED_RENTAL_EXISTING_MACHINE",
    OPEN_POPUP_FIXED_RENTAL_RENEWAL: "OPEN_POPUP_FIXED_RENTAL_RENEWAL",
    OPEN_POPUP_FIXED_RENTAL_RENEWAL_MACHINE: "OPEN_POPUP_FIXED_RENTAL_RENEWAL_MACHINE",
    OPEN_POPUP_FIXED_RENTAL_DEACTIVATE: "OPEN_POPUP_FIXED_RENTAL_DEACTIVATE",

    OPEN_POPUP_CREATE_IMAGE: "OPEN_POPUP_CREATE_IMAGE",
    OPEN_POPUP_BOOT_MACHINE: "OPEN_POPUP_BOOT_MACHINE",
    OPEN_POPUP_DOWNLOAD_REMOTE_DESKTOP: "OPEN_POPUP_DOWNLOAD_REMOTE_DESKTOP",
    OPEN_POPUP_CLONE_IMAGE: "OPEN_POPUP_CLONE_IMAGE",
    OPEN_POPUP_CHANGE_SERVICE_PACKAGE: "OPEN_POPUP_CHANGE_SERVICE_PACKAGE",
    OPEN_POPUP_SETTINGS_MACHINE: "OPEN_POPUP_SETTINGS_MACHINE",
    OPEN_POPUP_RENAME_IMAGE: "OPEN_POPUP_RENAME_IMAGE",
    OPEN_POPUP_SNAPSHOT_IMAGE: "OPEN_POPUP_SNAPSHOT_IMAGE",
    OPEN_POPUP_REMOVE_IMAGE: "OPEN_POPUP_REMOVE_IMAGE",
    OPEN_POPUP_SHUTDOWN_MACHINE: "OPEN_POPUP_SHUTDOWN_MACHINE",
    OPEN_POPUP_HARDWARE_FIXATION: "OPEN_POPUP_HARDWARE_FIXATION",
    OPEN_POPUP_SCHEDULER_MACHINE: "OPEN_POPUP_SCHEDULER_MACHINE",
    OPEN_POPUP_RESTART_MACHINE: "OPEN_POPUP_RESTART_MACHINE",
    OPEN_POPUP_RESET_MACHINE: "OPEN_POPUP_RESET_MACHINE",
    OPEN_POPUP_DISCONNECT_INTERNET_MACHINE: "OPEN_POPUP_DISCONNECT_INTERNET_MACHINE",
    OPEN_POPUP_ACTIVATE_SOFTWARE_LICENSE: "OPEN_POPUP_ACTIVATE_SOFTWARE_LICENSE",
    OPEN_POPUP_PROCESS_MONITORING: "OPEN_POPUP_PROCESS_MONITORING",

    OPEN_POPUP_EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD: "OPEN_POPUP_EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD",
    OPEN_POPUP_EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD: "OPEN_POPUP_EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD",
    OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT: "OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT",
    OPEN_POPUP_EXTRA_SERVICE_NVLINK: "OPEN_POPUP_EXTRA_SERVICE_NVLINK",
    OPEN_POPUP_EXTRA_SERVICE_PARSEC: "OPEN_POPUP_EXTRA_SERVICE_PARSEC",
    OPEN_POPUP_EXTRA_SERVICE_HARDWARE_CHANGE: "OPEN_POPUP_EXTRA_SERVICE_HARDWARE_CHANGE",
    OPEN_POPUP_EXTRA_SERVICE_LICENSE: "OPEN_POPUP_EXTRA_SERVICE_LICENSE",
    OPEN_POPUP_EXTRA_SERVICE_REPORT_ISSUES: "OPEN_POPUP_EXTRA_SERVICE_REPORT_ISSUES",

    CLICK_REFRESH_MACHINE_LIST_VIEW: "CLICK_REFRESH_MACHINE_LIST_VIEW",
    BOOT_IMAGE_MULTI: "BOOT_IMAGE_MULTI",
    CLICK_REFRESH_EXTRA_SERVICE_HISTORY_VIEW: "CLICK_REFRESH_EXTRA_SERVICE_HISTORY_VIEW",
    CLICK_REFRESH_FIXED_RENTAL_VIEW: "CLICK_REFRESH_FIXED_RENTAL_VIEW",
    SEARCH_TYPING_MACHINE_LIST_VIEW_IMMEDIATELY: "SEARCH_TYPING_MACHINE_LIST_VIEW_IMMEDIATELY",
    SEARCH_TYPING_MACHINE_LIST_VIEW: "SEARCH_TYPING_MACHINE_LIST_VIEW",
}

// Pop-up ID
export const POPUP_ID = {
    FIXED_RENTAL_CREATE: "fixed-rental-create",
    FIXED_RENTAL_EXISTING_MACHINE: "fixed-rental-existing-machine",
    FIXED_RENTAL_RENEWAL: "fixed-rental-renewal",
    FIXED_RENTAL_RENEWAL_MACHINE: "fixed-rental-renewal-machine",
    FIXED_RENTAL_DEACTIVATE: "fixed-rental-deactivate",
    FIXED_RENTAL_SETTINGS: "fixed-rental-settings",

    CREATE_IMAGE: "create-image",
    BOOT_MACHINE: "boot-machine",
    DOWNLOAD_REMOTE_DESKTOP: "download-remote-desktop",
    REMOVE_IMAGE: "remove-image",
    CHANGE_SERVICE_PACKAGE: "change-service-package",
    SETTINGS_MACHINE: "settings-machine",
    RENAME_IMAGE: "rename-image",
    SNAPSHOT_IMAGE: "snapshot-image",
    CLONE_IMAGE: "clone-image",
    SHUTDOWN_MACHINE: "shutdown-machine",
    HARDWARE_FIXATION: "hardware-fixation",
    SCHEDULER_MACHINE: "scheduler-machine",
    RESTART_MACHINE: "restart-machine",
    RESET_MACHINE: "reset-machine",
    DISCONNECT_INTERNET_MACHINE: "disconnect-internet-machine",
    ACTIVATE_SOFTWARE_LICENSE: "turn-on-off-license",
    PROCESS_MONITORING: "process-monitoring",

    RATE_IMAGE: "rate-image",

    EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD: "extra-service-image-threshold",
    EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD: "extra-service-storage-threshold",
    EXTRA_SERVICE_OPEN_PORT: "extra-service-open-port",
    EXTRA_SERVICE_NVLINK: "extra-service-nvlink",
    EXTRA_SERVICE_PARSEC: "extra-service-parsec",
    EXTRA_SERVICE_HARDWARE_CHANGE: "extra-service-hardware-change",
    EXTRA_SERVICE_LICENSE: "extra-service-license",
    EXTRA_SERVICE_REPORT_ISSUES: "extra-service-report-issues",
}

// Pop-up name
export const POPUP_NAME = {
    FIXED_RENTAL_CREATE: "FixedRentalCreate",
    FIXED_RENTAL_EXISTING_MACHINE: "FixedRentalExistingMachine",
    FIXED_RENTAL_RENEWAL: "FixedRentalRenewal",
    FIXED_RENTAL_RENEWAL_MACHINE: "FixedRentalRenewalMachine",
    FIXED_RENTAL_DEACTIVATE: "FixedRentalDeactivate",
    FIXED_RENTAL_SETTINGS: "FixedRentalSettings",

    EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD: "ExtraServiceExpandImageThreshold",
    EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD: "ExtraServiceExpandStorageThreshold",
    EXTRA_SERVICE_OPEN_PORT: "ExtraServiceOpenPort",
    EXTRA_SERVICE_NVLINK: "ExtraServiceNvlink",
    EXTRA_SERVICE_PARSEC: "ExtraServiceParsec",
    EXTRA_SERVICE_HARDWARE_CHANGE: "ExtraServiceHardwareChange",
    EXTRA_SERVICE_LICENSE: "ExtraServiceLicense",
    EXTRA_SERVICE_REPORT_ISSUES: "ExtraServiceReportIssues",

    CHANGE_PASSWORD: "ChangePassword",
    CREATE_IMAGE: "CreateImage",
    BOOT_MACHINE: "BootMachine",
    DOWNLOAD_REMOTE_DESKTOP: "DownloadRemoteDesktop",
    REMOVE_IMAGE: "RemoveImage",
    CHANGE_SERVICE_PACKAGE: "ChangeServicePackage",
    SETTINGS_MACHINE: "SettingsMachine",
    RENAME_IMAGE: "RenameImage",
    SNAPSHOT_IMAGE: "SnapshotImage",
    CLONE_IMAGE: "CloneImage",
    SHUTDOWN_MACHINE: "ShutdownMachine",
    HARDWARE_FIXATION: "HardwareFixation",
    SCHEDULER_MACHINE: "SchedulerMachine",
    RESTART_MACHINE: "RestartMachine",
    RESET_MACHINE: "ResetMachine",
    DISCONNECT_INTERNET_MACHINE: "DisconnectInternetMachine",
    ACTIVATE_SOFTWARE_LICENSE: "ActivateSoftwareLicense",
    PROCESS_MONITORING: "ProcessMonitoring"
}